import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Header, MessageService } from "primeng/api";
import { AppComponent } from "../app.component";
import { LoginInfo, LoginModel } from "../core/models/authentication";
import { ApiService, JwtService, UserService } from "../core/services";
import { HttpHeaders } from "@angular/common/http";

@Component({
  selector: "app-login",
  styleUrls: ['./app.login.component.scss'],
  templateUrl: "./app.login.component.html",
})
export class AppLoginComponent implements OnInit {
  public loginModel: LoginModel;
  showPassword: boolean = false;
  isLoading: boolean = false;
  public logoImage: string;
  errorMessage: string = '';

  // public loginForm = this.fb.group({
  //   userName: this.fb.control("", Validators.required),
  //   password: this.fb.control("", Validators.required),
  //   rememberMe: this.fb.control(false)
  // });
  public loginForm: FormGroup;

  constructor(
    public app: AppComponent,
    private apiService: ApiService,
    private userService: UserService,
    private router: Router,
    private fb: FormBuilder,
    private messageService: MessageService,
    private translate: TranslateService
  ) {
    this.loginForm = this.fb.group({
      userName: ['', Validators.required],
      password: ['', Validators.required],
      rememberMe: [false]
    });
  }
  ngOnInit(): void {
    this.loginModel = {} as LoginModel;
    this.loadImage();
  }

  public onLogin(): void {
    if (this.loginForm.valid) {
      this.isLoading = true;
      this.errorMessage = '';
      this.loginModel = this.loginForm.value;

      // const headers = new HttpHeaders();
      // headers.append("Access-Control-Allow-Origin", "*");
      this.apiService
        .post("api/account/login", this.loginModel, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
        })
        .toPromise()
        .then((th) => {
          const loginInfo: LoginInfo = th;
          this.userService.setAuth(loginInfo);
          if (this.userService.HasRole("admin")) {
            this.router.navigateByUrl("/dashboard/admin");
          } else if (this.userService.HasRole("doctor")) {
            this.router.navigateByUrl("/dashboard/doctor");
          } else if (this.userService.HasRole("reception")) {
            this.router.navigateByUrl("/dashboard/reception");
          } else if (this.userService.HasRole("rentgen")) {
            this.router.navigateByUrl("/dashboard/rentgen");
          } else {
            this.router.navigateByUrl("/dashboard/cashier/invoice");
          }
        })
        .catch((error) => {
          this.errorMessage = this.translate.instant("ERROR_ON_LOGIN");
          this.messageService.add({
            severity: "error",
            summary: this.translate.instant("ERROR"),
            detail: this.translate.instant("ERROR_ON_LOGIN"),
            life: 3000,
          });
        })
        .finally(() => { this.isLoading = false; });
    } else{
      this.errorMessage = this.translate.instant("PLEASE_FILL_FORM_CORRECTLY");
    
    }
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  loadImage() {
    const cachedLogo = localStorage.getItem('loginLogo');
    
    if (cachedLogo) {
      this.logoImage = cachedLogo;
    } else {
      const img = new Image();
      img.src = 'assets/layout/images/bg-dent.jpg';
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx?.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL('image/jpeg');
        localStorage.setItem('loginLogo', dataURL);
        this.logoImage = dataURL;
      };
    }
  }
}
